import { Injectable }    from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';


@Injectable()
export class ApiService {
    private apiUrl;


    constructor(private http: Http, private router: Router) {
        this.apiUrl = environment.apiUrl;
    }

    getApiUrl(){
        return this.apiUrl;
    }
    /**
     * GET a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @return Promise<T>
     */
    get(endpoint: string) {
        return new Promise((resolve, reject) => {
            this.http.get(this.apiUrl + endpoint, this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            });
        });
    }

    /**
     * PATCH a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @param body - The to send, eg. {firstName: 'Winter'}
     * @return Promise<T>
     */
    patch(endpoint: string, body: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.patch(this.apiUrl + endpoint, body, this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            })
        });
    }

    /**
     * POST a resource from the API
     * @param endpoint - The endpoint, eg. applications
     * @param body - The to send, eg. {firstName: 'Winter'}
     * @return Promise<T>
     */
    post(endpoint: string, body: any = {}) {
        return new Promise((resolve, reject) => {
            this.http.post(this.apiUrl + endpoint, body, this.getHeaders()).subscribe((res) => {
                let response = res.json();
                resolve(response);
            }, (err) => {
                this.handleExpiredSession(err, reject);
            })
        });
    }

    getRandomSpotifyTrack(spotifyAccessToken, spotifyUserId = 'spotifycharts', spotifyPlaylistId = '37i9dQZEVXbMDoHDwVN2tF') {
      return new Promise((resolve, reject) => {
          this.http.get('https://api.spotify.com/v1/users/' + spotifyUserId + '/playlists/' + spotifyPlaylistId, this.getSpotifyHeaders(spotifyAccessToken)).subscribe((res) => {
              let response = res.json();
              resolve(response);
          }, (err) => {
              //this.handleExpiredSession(err, reject);
             resolve('invalidToken');
          })
      });
    }

    getHeaders() {
        let headers = new Headers();
        headers.append('Authorization', localStorage.getItem('token'));

        return new RequestOptions({ headers: headers });
    }

    getSpotifyHeaders(spotifyAccessToken) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + spotifyAccessToken);

        return new RequestOptions({ headers: headers });
    }

    authenticate(data: any) {
        return new Promise((resolve, reject) => {
            this.http.post(this.apiUrl + 'authentication', data).subscribe((res) => {
                let response = res.json();

                // Save token in localStorage
                localStorage.setItem("token", response.accessToken);

                resolve(response.data);
            }, (err) => {
                reject(err);
            });
        });
    }

    isAuthenticated() {
        return new Promise((resolve, reject) => {
            let accessToken = localStorage.getItem('token');

            if(accessToken !== null) {
                this.post('authentication').then((res) => {
                    resolve(true);
                }).catch((err) => {
                    reject(err);
                });
            } else {
                reject('No token found');
            }
        });
    }

    handleExpiredSession(err, reject) {
        if(err.status == 401) {
            localStorage.removeItem("email");
            localStorage.removeItem("token");
            localStorage.setItem('sessionExpired', 'true');
            this.router.navigateByUrl('login');
        }

        reject(err);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts